export const API_BASE_URL = 'https://mtgparley.com/api';
export const BACKEND_BASE_URL = 'https://mtgparley.com';
